import { render } from "./LogoutIcon.vue?vue&type=template&id=3f9cf3a6&scoped=true&ts=true"
import script from "./LogoutIcon.vue?vue&type=script&lang=tsx"
export * from "./LogoutIcon.vue?vue&type=script&lang=tsx"

import "./LogoutIcon.vue?vue&type=style&index=0&id=3f9cf3a6&lang=less&scoped=true"

import exportComponent from "/home/jenkins_home/workspace/c1-02_dwart2.0-apkpc-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f9cf3a6"]])

export default __exports__